import {useMemo,useRef} from 'react';
import {useUi} from './config';
import {useIncreasingNumber} from './useIncreasingNumber';
import {useIncreaseEmphasis} from './useIncreaseEmphasis';
import './SalesCount.css';

export function SalesCount({count,identity,template='{count}'}:{count:number|undefined;identity:string;template?:string}){
 if(count===undefined)return <>{template.replace('{count}','—')}</>;
 return <AnimatedCount key={identity} count={count} template={template}/>;
}
function AnimatedCount({count,template}:{count:number;template:string}){
 const locale=useUi().controls.prizeDisplayLocale,ref=useRef<HTMLSpanElement>(null);
 const formatter=useMemo(()=>new Intl.NumberFormat(locale,{maximumFractionDigits:0}),[locale]);
 const shown=useIncreasingNumber(count,formatter);
 useIncreaseEmphasis(ref,count,'sales',{effect:'weight'});
 const [prefix,suffix='']=template.split('{count}');
 return <span>{prefix&&<span className="sales-count-caption">{prefix}</span>}<span ref={ref} className="sales-count-number">{shown}</span>{suffix&&<span className="sales-count-caption">{suffix}</span>}</span>;
}
